export * from './createComponent';
export * from './IComponent';
export * from './IHTMLSlots';
export * from './ISlots';
export * from './slots';
export * from './ThemeProvider';

import './version';
